import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

const friendlyLinks = ['韩漫社区', '漫画同好会', '二次元资讯', '版权声明'];

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="w-full bg-accent-950 text-background-100 mt-16">
      <div className="w-full px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 md:gap-10">
          <div className="md:col-span-2 max-w-md">
            <div className="flex items-center gap-2">
              <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-book-open-line text-xl"></i>
              </span>
              <span className="font-heading font-extrabold text-2xl text-background-50">韩漫</span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-background-200/90">
              韩漫是一个专注于韩漫漫画资源聚合与推荐的阅读平台，汇聚爱情、奇幻、悬疑、治愈等多元题材，
              为喜爱韩国漫画的你提供便捷的浏览、筛选与发现体验。
            </p>
          </div>

          <div>
            <h4 className="font-heading font-bold text-background-50 mb-4">
              <Link to="/" className="cursor-pointer hover:text-primary-300 transition-colors">热门题材</Link>
            </h4>
            <ul className="grid grid-cols-2 gap-y-2 gap-x-3">
              {categories.slice(0, 8).map((cat) => (
                <li key={cat.id}>
                  <Link
                    to={`/category/${cat.id}`}
                    className="text-sm text-background-200/90 hover:text-primary-300 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    {cat.name}漫画
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-bold text-background-50 mb-4">
              <Link to="/about" className="cursor-pointer hover:text-primary-300 transition-colors">关于与帮助</Link>
            </h4>
            <ul className="flex flex-col gap-2">
              <li>
                <Link to="/about" className="text-sm text-background-200/90 hover:text-primary-300 transition-colors cursor-pointer">
                  关于我们
                </Link>
              </li>
              {friendlyLinks.map((item) => (
                <li key={item}>
                  <span className="text-sm text-background-200/90 cursor-pointer hover:text-primary-300 transition-colors">
                    {item}
                  </span>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-200/20 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-200/70">
            © {year} 韩漫 hanman.example.com · 本站内容均为演示数据，仅供学习参考
          </p>
          <p className="text-xs text-background-200/70">本站不存储任何漫画资源，版权归原作者所有</p>
        </div>
      </div>
    </footer>
  );
}